const cfg = {
    chessandcard: {
        PG棋牌: "Hall/ChessAndCard/qipai_00",
        EG棋牌: "Hall/ChessAndCard/qipai_01",
        开元棋牌: "Hall/ChessAndCard/qipai_02",
        新世界棋牌: "Hall/ChessAndCard/qipai_03",
        FG棋牌: "Hall/ChessAndCard/qipai_04",
        大富翁棋牌: "Hall/ChessAndCard/qipai_05",
        美天棋牌: "Hall/ChessAndCard/qipai_06",
        乐游棋牌: "Hall/ChessAndCard/qipai_07",
        财神棋牌: "Hall/ChessAndCard/qipai_08",
        JDB棋牌: "Hall/ChessAndCard/qipai_09",
        MW棋牌: "Hall/ChessAndCard/qipai_10",
        天豪棋牌: "Hall/ChessAndCard/qipai_11",
        黑桃棋牌: "Hall/ChessAndCard/qipai_13",
        龙游棋牌: "Hall/ChessAndCard/qipai_14",
        CQ9棋牌: "Hall/ChessAndCard/qipai_15",
        百胜棋牌: "Hall/ChessAndCard/qipai_16",
        DT棋牌: "Hall/ChessAndCard/qipai_17",
    },

    fish: {
    },

    electronic: {
        BG电子: "Hall/Electronic/dianzi_00",
        天豪电子: "Hall/Electronic/dianzi_01",
        PT电子: "Hall/Electronic/dianzi_02",
        MW电子: "Hall/Electronic/dianzi_03",
        PP电子: "Hall/Electronic/dianzi_04",
        PG电子: "Hall/Electronic/dianzi_05",
        MG电子: "Hall/Electronic/dianzi_06",
        FG电子: "Hall/Electronic/dianzi_07",
        AG电子: "Hall/Electronic/dianzi_08",
        SG电子: "Hall/Electronic/dianzi_09",
        JDB电子: "Hall/Electronic/dianzi_10",
        美天电子: "Hall/Electronic/dianzi_11",
        CQ9电子: "Hall/Electronic/dianzi_12",
        JDB电子彩票: "Hall/Electronic/dianzi_13",
        黑桃电子: "Hall/Electronic/dianzi_14",
        龙游电子: "Hall/Electronic/dianzi_15",
        BBIN电子: "Hall/Electronic/dianzi_16",
        大富翁电子: "Hall/Electronic/dianzi_17",
        乐游电子: "Hall/Electronic/dianzi_18",
        百胜电子: "Hall/Electronic/dianzi_19",
        王者电子: "Hall/Electronic/dianzi_20",
        DT电子: "Hall/Electronic/dianzi_21",
        SEA电子: "Hall/Electronic/dianzi_22",
        ICG电子: "Hall/Electronic/dianzi_23",
    },

    sports: {
        "188体育": "Hall/Sports/188",
        "189体育": "Hall/Sports/189",
        皇冠体育: "Hall/Sports/huangguan",
        利记体育: "Hall/Sports/liji",
        沙巴体育: "Hall/Sports/shaba",
        BTi体育: "Hall/Sports/bti",
        BTI体育: "Hall/Sports/bti",
        三昇体育: "Hall/Sports/sansheng",
        "斗鸡": "Hall/Sports/douji",
        利记体育中文:"Hall/Sports/liji",
        IM体育:"Hall/Sports/im",

    },

    lottery: {
    },

    esports: {
        IM电竞: "Hall/ESports/dianjing_00",
        RG电竞: "Hall/ESports/dianjing_01",
        泛亚电竞: "Hall/ESports/dianjing_02",
        雷火电竞: "Hall/ESports/dianjing_03",
    },

    livevideo: {
        BG视讯: "Hall/LiveVideo/bg",
        AG视讯: "Hall/LiveVideo/ag",
        BBIN视讯: "Hall/LiveVideo/bb",
        PT视讯: "Hall/LiveVideo/pt",
        EVO视讯: "Hall/LiveVideo/evo",
        欧博视讯: "Hall/LiveVideo/ob",
        IG视讯: "Hall/LiveVideo/ig",
        DG视讯: "Hall/LiveVideo/dg",
        EBET视讯: "Hall/LiveVideo/ebet",
        王者视讯: "Hall/LiveVideo/play",
        AE真人:"Hall/LiveVideo/ae",
        RIBOLV真人:"Hall/LiveVideo/xj",
    },
}

export default cfg